import "core-js/modules/es.string.link.js";
import styled from "styled-components";
import { Box, Link } from "@pochta/ui";
export var MenuBox = styled.div.withConfig({
  displayName: "Menustyles__MenuBox",
  componentId: "sc-e7l2ct-0"
})(["", "{display:none;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.notDesktop;
});
export var MenuItems = styled(Box).withConfig({
  displayName: "Menustyles__MenuItems",
  componentId: "sc-e7l2ct-1"
})(["position:relative;display:flex;flex:1 0;align-items:stretch;margin:0 -8px;"]);
export var MenuItem = styled(Link).withConfig({
  displayName: "Menustyles__MenuItem",
  componentId: "sc-e7l2ct-2"
})(["&&&{display:flex;align-items:center;margin-bottom:-1px;padding:0 8px;border-bottom-width:2px;height:42px;font-family:inherit;color:", ";position:relative;border-bottom-color:transparent;outline:none;&:visited{color:", ";border-bottom-color:transparent;}&:hover{color:", ";border-bottom-color:transparent;}}"], function (_ref2) {
  var text = _ref2.theme.color.text,
      active = _ref2.active;
  return active ? text.link.base : text.black.base;
}, function (_ref3) {
  var text = _ref3.theme.color.text,
      active = _ref3.active;
  return active ? text.link.base : text.black.base;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.text.link.base;
});
export var Underline = styled(Box).withConfig({
  displayName: "Menustyles__Underline",
  componentId: "sc-e7l2ct-3"
})(["background:", ";position:absolute;left:0;bottom:0;height:1px;transition:", ";transform:translate(", "px,0);"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.text.link.base;
}, function (_ref6) {
  var _ref6$transition = _ref6.transition,
      transition = _ref6$transition === void 0 ? true : _ref6$transition;
  return transition ? "all 0.2s ease-in-out" : "all 0s ease 0s";
}, function (_ref7) {
  var leftTransition = _ref7.leftTransition;
  return leftTransition;
});